/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as ActorDefs from "../../../app/bsky/actor/defs.defs.js";

const $nsid = "place.stream.vod.defs";

export { $nsid };

type CommentView = { $type?: "place.stream.vod.defs#commentView";"uri":l.AtUriString;"cid":l.CidString;"author":ActorDefs.ProfileViewBasic;"record":l.LexMap;"indexedAt":l.DatetimeString;

  /**
   * The parent comment this one replies to, if any. A non-recursive view (it carries no replyTo of its own), so the thread is flattened to a single hop; walk `record.reply` to follow the chain further.
   */
  "replyTo"?:l.$Typed<CommentViewBasic> | l.Unknown$TypedObject;

  /**
   * Number of likes on this comment.
   */
  "likeCount":number };

export type { CommentView };

const commentView = /*#__PURE__*/ l.typedObject<CommentView>($nsid, "commentView", /*#__PURE__*/ l.object({"uri":/*#__PURE__*/ l.string({"format":"at-uri"}),"cid":/*#__PURE__*/ l.string({"format":"cid"}),"author":/*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>((() => ActorDefs.profileViewBasic) as any),"record":/*#__PURE__*/ l.lexMap(),"indexedAt":/*#__PURE__*/ l.string({"format":"datetime"}),"replyTo":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<CommentViewBasic>((() => commentViewBasic) as any)], false)),"likeCount":/*#__PURE__*/ l.integer({"minimum":0})}));

export { commentView };

/** A comment view without its own `replyTo`, used to represent the parent of a reply without recursively nesting the whole thread. */
type CommentViewBasic = { $type?: "place.stream.vod.defs#commentViewBasic";"uri":l.AtUriString;"cid":l.CidString;"author":ActorDefs.ProfileViewBasic;"record":l.LexMap;"indexedAt":l.DatetimeString;

  /**
   * Number of likes on this comment.
   */
  "likeCount":number };

export type { CommentViewBasic };

/** A comment view without its own `replyTo`, used to represent the parent of a reply without recursively nesting the whole thread. */
const commentViewBasic = /*#__PURE__*/ l.typedObject<CommentViewBasic>($nsid, "commentViewBasic", /*#__PURE__*/ l.object({"uri":/*#__PURE__*/ l.string({"format":"at-uri"}),"cid":/*#__PURE__*/ l.string({"format":"cid"}),"author":/*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>((() => ActorDefs.profileViewBasic) as any),"record":/*#__PURE__*/ l.lexMap(),"indexedAt":/*#__PURE__*/ l.string({"format":"datetime"}),"likeCount":/*#__PURE__*/ l.integer({"minimum":0})}));

export { commentViewBasic };
